import { REQUEST_VITALS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type Response = {
    success: boolean;
    error?: string;
};

export type RequestBody = {
    patientid: string;
    vitals: { id: string; name: string }[];
};

export default (request: RequestBody): Promise<Response> => {
    return fetchWithRefresh(REQUEST_VITALS, {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => {
        if (res.status === 200 || res.status === 400) {
            return res.json();
        } else {
            throw new Error('failed to request vitals');
        }
    });
};
